import { render } from "./CategoryView.vue?vue&type=template&id=fec4468a"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__